import * as consts from 'redux/constants';

const stateKeys = {
  applePay: 'applePay',
  supportedProviders: 'supportedProviders'
};
const initialState = {
  [stateKeys.applePay]: {
    deviceSupported: false
  },
  [stateKeys.supportedProviders]: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case consts.UPDATE_APPLE_PAY_SUPPORTED_DEVICE: {
      const { supported } = action.payload;
      return {
        ...state,
        applePay: {
          ...state.applePay,
          deviceSupported: supported
        }
      };
    }
    case consts.UPDATE_SUPPORTED_DIGITAL_PROVIDER: {
      const { providerName } = action.payload;

      if (state[stateKeys.supportedProviders].includes(providerName)) return state;
      return {
        ...state,
        [stateKeys.supportedProviders]: [
          ...state[stateKeys.supportedProviders],
          providerName
        ]
      };
    }
    default:
      return state;
  }
};

export default reducer;
